import { 
  LIVE_RELOAD_INTERVAL,
} from "@/processes/Settings";

export const selectLiveReload = (state: any) => state.settings.isLiveReload;
export const selectPollingInterval = (state: any) => state.settings.isLiveReload ? (LIVE_RELOAD_INTERVAL * 1000) : 0;
export const selectDateRange = (state: any) => state.settings.dateRange;
